import { createAsyncThunk } from "@reduxjs/toolkit";
// Types
import Reducers from "types/Reducers";
// Utilities
import fetcher from "utilities/Fetcher";

const _url:string = '/player/consent';

export const getConsentDocuments = createAsyncThunk(
  `${Reducers.Consent}/Get consent documents`,
  async (ids:string[], { rejectWithValue }) => {

    const response:Response = await fetcher(`${_url}/documents?ids=${ids.join(',')}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json'
      }
    });
    if ( !response.ok ) return rejectWithValue((await response.json()) as any);
    return response.json();
  }
);
